import remoInvertidoImage from '../assets/exercises/remo-invertido.jpg'
import dominadasImage from '../assets/exercises/dominadas.jpg'
import hollowHoldImage from '../assets/exercises/hollow-hold.jpg'
import amrapImage from '../assets/exercises/amrap-circuito.jpg'

export const daysHeader = ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom']

export const monthNames = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]

export const militaryPosterExercises = [
  { id: 1, name: 'Push-Ups', prescription: '10-15 x 3' },
  { id: 2, name: 'Squat Jumps', prescription: '10-15 x 3' },
  { id: 3, name: 'Lunges', prescription: '10 por pierna x 3' },
  { id: 4, name: 'Plank Hold', prescription: '30-45 seg x 3' },
  { id: 5, name: 'Mountain Climbers', prescription: '30-45 seg x 3' },
  { id: 6, name: 'Crunches', prescription: '15-20 x 3' },
  { id: 7, name: 'High Knees', prescription: '30-45 seg x 3' },
  { id: 8, name: 'Air Squats', prescription: '15-20 x 3' },
  { id: 9, name: 'Burpees', prescription: '8-12 x 3' },
  { id: 10, name: 'Tricep Dips', prescription: '10-15 x 3' },
  { id: 11, name: 'Plank Shoulder Taps', prescription: '10-15 por lado x 3' },
  { id: 12, name: 'Bear Crawl', prescription: '30-45 seg x 3' },
  { id: 13, name: 'Side Plank', prescription: '30-45 seg por lado x 3' },
  { id: 14, name: 'Leg Raises', prescription: '12-15 x 3' },
  { id: 15, name: 'Russian Twists', prescription: '20 total x 3' },
  { id: 16, name: 'Jump Lunges', prescription: '10 por pierna x 3' },
  { id: 17, name: 'V-Ups', prescription: '12-15 x 3' },
  { id: 18, name: 'Superman Hold', prescription: '20-30 seg x 3' },
  { id: 19, name: 'Plank Jacks', prescription: '30-45 seg x 3' },
  { id: 20, name: 'Sit-Ups', prescription: '15-20 x 3' },
]

export const posterImage =
  'https://i.etsystatic.com/63861990/r/il/19e38e/7980043908/il_1140xN.7980043908_4dec.jpg'

export const posterSprite = {
  width: 768,
  height: 768,
  startX: 110,
  startY: 96,
  cellWidth: 137,
  cellHeight: 121,
  gapX: 1,
  gapY: 1,
  scale: 2,
}

export const muscleTargets = {
  empuje: 'Pecho, triceps, hombros y core',
  traccion: 'Espalda, biceps, antebrazos y core',
  piernas: 'Cuadriceps, gluteos, femorales y core',
  resistencia: 'Core, piernas, gluteos y deltoides',
}

export function toISODate(date) {
  const year = date.getFullYear()
  const month = `${date.getMonth() + 1}`.padStart(2, '0')
  const day = `${date.getDate()}`.padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function extractFocusKey(focus) {
  const normalized = focus.toLowerCase()
  if (normalized.includes('empuje')) return 'empuje'
  if (normalized.includes('traccion')) return 'traccion'
  if (normalized.includes('piernas')) return 'piernas'
  return 'resistencia'
}

// Devuelve null cuando el poster de referencia (solo empuje/piernas/core) no
// tiene ninguna imagen que represente honestamente el ejercicio, en vez de
// adivinar una imagen no relacionada (ej: mostrar Mountain Climbers para un
// ejercicio de remo).
export function getPosterExerciseId(name, motion) {
  const value = name.toLowerCase()

  if (value.includes('toque de hombro') || value.includes('shoulder tap')) return 11
  if (value.includes('mountain')) return 5
  if (value.includes('high knees') || value.includes('carrera')) return 7
  if (value.includes('air squat')) return 8
  if (value.includes('burpee')) return 9
  if (value.includes('fondos') || value.includes('tricep dip')) return 10
  if (value.includes('bear crawl')) return 12
  if (value.includes('side plank') || value.includes('plancha lateral')) return 13
  if (value.includes('leg raises') || value.includes('elevacion')) return 14
  if (value.includes('russian')) return 15
  if (value.includes('jump lunge')) return 16
  if (value.includes('v-up')) return 17
  if (value.includes('superman')) return 18
  if (value.includes('plank jack')) return 19
  if (value.includes('sit-up') || value.includes('abdominal')) return 20
  if (value.includes('flexiones') || value.includes('push-up')) return 1
  if (value.includes('squat jump')) return 2
  if (value.includes('zancada') || value.includes('lunge')) return 3
  if (value.includes('plancha')) return 4
  if (value.includes('sentadilla')) return 8

  // Sin coincidencia de nombre: solo usamos el motion como respaldo para los
  // movimientos que el poster realmente cubre. Remo/dominadas ("pull") y
  // circuitos genericos ("cardio") no tienen equivalente real en el poster.
  if (motion === 'push') return 1
  if (motion === 'squat') return 8
  if (motion === 'lunge') return 3
  if (motion === 'plank') return 4
  if (motion === 'dip') return 10
  if (motion === 'burpee') return 9
  if (motion === 'run') return 7
  return null
}

// Ejercicios de traccion y circuitos genericos que el poster de referencia
// no ilustra (ver getPosterExerciseId). Para estos usamos fotos propias en
// vez de dejar el thumbnail vacio.
const customExerciseImages = [
  { match: (value) => value.includes('remo'), src: remoInvertidoImage },
  { match: (value) => value.includes('dominadas'), src: dominadasImage },
  { match: (value) => value.includes('hollow hold'), src: hollowHoldImage },
  { match: (value) => value.includes('amrap'), src: amrapImage },
]

export function getCustomExerciseImage(name) {
  const value = name.toLowerCase()
  const found = customExerciseImages.find((entry) => entry.match(value))
  return found ? found.src : null
}

export function getExerciseDemo(name) {
  const value = name.toLowerCase()

  if (value.includes('flexiones')) {
    return { motion: 'push', targets: ['pecho', 'triceps', 'hombros', 'core'], title: 'Flexion militar' }
  }

  if (value.includes('fondos')) {
    return { motion: 'dip', targets: ['triceps', 'pecho', 'hombros'], title: 'Fondo en banco' }
  }

  if (value.includes('plancha')) {
    return { motion: 'plank', targets: ['core', 'hombros'], title: 'Plancha activa' }
  }

  if (value.includes('remo') || value.includes('dominadas')) {
    return { motion: 'pull', targets: ['espalda', 'biceps', 'core'], title: 'Trabajo de traccion' }
  }

  if (value.includes('sentadilla')) {
    return { motion: 'squat', targets: ['piernas', 'gluteos', 'core'], title: 'Sentadilla' }
  }

  if (value.includes('zancadas')) {
    return { motion: 'lunge', targets: ['piernas', 'gluteos', 'core'], title: 'Zancada alterna' }
  }

  if (value.includes('burpees')) {
    return { motion: 'burpee', targets: ['full'], title: 'Burpee tactico' }
  }

  if (value.includes('carrera')) {
    return { motion: 'run', targets: ['piernas', 'gluteos', 'core'], title: 'Carrera por intervalos' }
  }

  if (value.includes('amrap')) {
    return { motion: 'cardio', targets: ['full'], title: 'Circuito AMRAP' }
  }

  return { motion: 'cardio', targets: ['core'], title: 'Entrenamiento funcional' }
}

const exerciseDescriptions = [
  {
    match: (value) => value.includes('flexiones'),
    text: 'Manos a la altura de los hombros, cuerpo en linea recta de cabeza a talones. Baja el pecho casi hasta tocar el suelo y empuja de vuelta sin arquear la espalda.',
  },
  {
    match: (value) => value.includes('fondos'),
    text: 'Apoya las manos en el borde de un banco, piernas extendidas al frente. Baja el cuerpo doblando los codos hasta 90 grados y empuja para subir sin encoger los hombros.',
  },
  {
    match: (value) => value.includes('toque de hombro'),
    text: 'En posicion de plancha alta, lleva una mano al hombro contrario alternando lados. Mantén la cadera estable y evita rotar el torso.',
  },
  {
    match: (value) => value.includes('remo'),
    text: 'Cuelgate de una barra baja con el cuerpo en linea recta y talones apoyados en el suelo. Tira del pecho hacia la barra apretando los omoplatos y baja controlado.',
  },
  {
    match: (value) => value.includes('dominadas'),
    text: 'Agarre pronado a la anchura de los hombros. Tira hacia arriba hasta que la barbilla pase la barra sin balancear el cuerpo, y baja controlando el descenso.',
  },
  {
    match: (value) => value.includes('hollow hold'),
    text: 'Acostado boca arriba, eleva brazos y piernas del suelo formando una curva con el cuerpo y la zona lumbar pegada al piso. Mantén la posicion respirando de forma constante.',
  },
  {
    match: (value) => value.includes('sentadilla'),
    text: 'Pies a la anchura de hombros, baja llevando la cadera hacia atras como si te sentaras en una silla, rodillas alineadas con los pies. Sube extendiendo cadera y rodillas por completo.',
  },
  {
    match: (value) => value.includes('zancadas'),
    text: 'Da un paso largo al frente y baja hasta que ambas rodillas formen 90 grados sin que la rodilla trasera toque el suelo. Empuja con el talon delantero para volver y alterna de pierna.',
  },
  {
    match: (value) => value.includes('burpees'),
    text: 'Desde de pie, baja a cuclillas, apoya las manos y lanza los pies atras hasta plancha. Haz una flexion, recupera los pies hacia las manos y salta extendiendo los brazos arriba.',
  },
  {
    match: (value) => value.includes('amrap'),
    text: 'Encadena las tres estaciones sin pausas largas, completando tantas rondas como puedas en 20 minutos manteniendo la tecnica de cada movimiento.',
  },
  {
    match: (value) => value.includes('carrera') || value.includes('intervalos'),
    text: 'Corre a ritmo alto durante 30 segundos y luego trota o camina 90 segundos para recuperar. Repite el ciclo controlando la respiracion en la fase suave.',
  },
  {
    match: (value) => value.includes('plancha frontal') || value.includes('plancha'),
    text: 'Apoya antebrazos y puntas de los pies, cuerpo en linea recta sin dejar caer ni levantar la cadera. Aprieta core y gluteos durante toda la serie.',
  },
]

export function getExerciseDescription(name) {
  const value = name.toLowerCase()
  const found = exerciseDescriptions.find((entry) => entry.match(value))
  return found ? found.text : null
}

export function parsePrescription(text) {
  const series = text.match(/(\d+)\s*series?/i)?.[1] ?? '-'
  const reps =
    text.match(/(\d+\s*a\s*\d+)\s*repeticiones?/i)?.[1] ??
    text.match(/(\d+)\s*repeticiones?/i)?.[1] ??
    text.match(/(\d+)\s*segundos?/i)?.[1] ??
    '-'

  return { series, reps }
}

export function completionKey(date, exerciseName) {
  return `${date}__${exerciseName}`
}

export function isDayComplete(dayPlan, date, completion) {
  if (!dayPlan) return false
  return dayPlan.exercises.every((exercise) => completion[completionKey(date, exercise.name)])
}

export function computeStreak(plan, completion) {
  const todayIso = toISODate(new Date())
  const past = Object.keys(plan)
    .filter((date) => date <= todayIso)
    .sort()
    .reverse()

  let streak = 0
  for (const date of past) {
    if (isDayComplete(plan[date], date, completion)) {
      streak += 1
    } else {
      break
    }
  }

  return streak
}

export function countCompletedSessions(plan, completion) {
  return Object.keys(plan).filter((date) => isDayComplete(plan[date], date, completion)).length
}
